<template>
    <div>
        <common-table
                :table-columns="tableColumns"
                :url="url" :operate="[]"
                :searchs="searchs"
                :form-fields="formFields"
                :permission="permission"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "Country",
        components: {CommonTable},
        data(){
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'name',
                    placeholder: '国家参数',
                    type: 'input',
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission:{
                    add: 'country:add',
                    update: 'country:update',
                    delete: 'country:delete',
                    deleteBatch: 'country:deleteBatch'
                },
                url: {
                    get: '/country/listByCondition',
                    add: '/country/add',
                    update: '/country/update',
                    delete: '/country/delete/',
                    delete_batch: '/country/deleteBatch',
                  status: '/country/status',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'name',
                    label: '国家参数',
                    show: true,
                    width: '',
                }, {
                  field: 'countryName',
                  label: '国家名称',
                  show: true,
                  width: '',
                }, {
                  field: 'status',
                  label: '状态',
                  show: true,
                  width: '90',
                  status: true,
                }, {
                  field: 'sort',
                  label: '排序',
                  show: true,
                  width: '',
                },{
                  field: 'timeZone',
                  label: '量化时间',
                  show: true,
                  width: '',
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'name',
                        label: '国家参数',
                        type: 'input',
                        placeholder: '国家参数',
                        rules:[{message: '请输入国家参数', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                      field: 'countryName',
                      label: '国家名称',
                      type: 'input',
                      placeholder: '国家名称',
                      rules:[{message: '请输入国家名称', trigger: 'blur', required: true}],
                      add: true,
                      update: true,
                    }, {
                      field: 'sort',
                      label: '排序',
                      type: 'input',
                      placeholder: '排序',
                      rules:[{message: '请输入排序', trigger: 'blur', required: true}],
                      add: true,
                      update: true,
                    },{
                      field: 'timeZone',
                      label: '量化时间',
                      type: 'input',
                      placeholder: '量化时间',
                      rules:[{message: '请输入量化时间', trigger: 'blur', required: true}],
                      add: true,
                      update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
